import { createFileRoute } from '@tanstack/react-router'
import { SignInForm } from '@/components/auth/sign-in-form'

export const Route = createFileRoute('/login')({
  component: LoginPage,
})

/**
 * Login page. Thin wrapper around <SignInForm /> — the form
 * component owns all the state, validation, error handling,
 * and 2FA challenge flow. Keeping the layout chrome here so
 * the centered card matches the existing design without
 * forcing every consumer of SignInForm to re-implement it.
 */
function LoginPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '420px',
          padding: '2rem',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
        }}
      >
        <h1 style={{ marginBottom: '1.5rem', fontSize: '1.5rem', fontWeight: 600 }}>Sign in</h1>
        <SignInForm />
        <p
          style={{
            marginTop: '1.5rem',
            textAlign: 'center',
            fontSize: '0.875rem',
            color: '#6b7280',
          }}
        >
          Don't have an account?{' '}
          <a
            href="/register"
            style={{
              color: '#2563eb',
              textDecoration: 'none',
              fontWeight: 500,
            }}
          >
            Sign up
          </a>
        </p>
      </div>
    </div>
  )
}
